// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ijcAy5CHcOQcOcJbnIBJ{position:absolute;inset:0}`, "",{"version":3,"sources":["webpack://./src/components/settings/views/my-settings/tenant-settings/tenant-settings-subpage.scss"],"names":[],"mappings":"AAAA,sBACI,iBAAA,CACA,OAAA","sourcesContent":[".subPageLayout {\n    position: absolute;\n    inset: 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"subPageLayout": `ijcAy5CHcOQcOcJbnIBJ`
};
export default ___CSS_LOADER_EXPORT___;
